import { LOGIN_PATHNAME, REGISTRATION_PATHNAME, VERIFICATION_PATHNAME } from '@/shared/constants/pathnames';
import { Button, Text } from '@/shared/ui/core';
import { LockIcon } from '@phosphor-icons/react/ssr';
import styles from './landing-login-controls.module.scss';


export function LandingLoginControls () {
    return (
        <>
            <Button
                as="a"
                href={ REGISTRATION_PATHNAME }
                variant='primary'
            >
                Start for free
            </Button>

            <Button
                as="a"
                href={ LOGIN_PATHNAME + '?callbackUrl=' + VERIFICATION_PATHNAME }
                variant='secondary'
                className={ styles.login_button }
                leftIcon={
                    <LockIcon size={ 16 }/>
                }
            >
                <Text
                    as='span'
                    className={ styles.login_label }
                >
                    Log in
                </Text>
            </Button>
        </>
    );
}
